import angular from 'angular';

const DEFAULT_TIMEOUT = 1000;
const MODULE_NAME = 'fullPageLoader';

let loaderService = () => {
	'nginject';
	return {
		show: () => {
			angular.element('body').addClass('show-loader');
		},
		hide: (timeout = null) => {
			let time = timeout ? timeout : DEFAULT_TIMEOUT;
			setTimeout(() => {
				angular.element('body').removeClass('show-loader');
			}, time);
		}
	};
};

export default angular.module(MODULE_NAME, []).service('loaderService', loaderService).name;


